import { render, staticRenderFns } from "./NewspaperDark.vue?vue&type=template&id=5bfce1a6&scoped=true&"
var script = {}
import style0 from "./NewspaperDark.vue?vue&type=style&index=0&id=5bfce1a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfce1a6",
  null
  
)

export default component.exports